import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoggedInGuard } from "../auth/auth.guards";
import { DocsComponent } from "./docs.component";

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "api",
  },
  {
    path: "api",
    component: DocsComponent,
    data: { title: "API Docs", docsSection: "api-docs" },
    canActivate: [LoggedInGuard],
  },
  {
    path: "api-reference",
    component: DocsComponent,
    data: { title: "API Reference", docsSection: "api-reference" },
    canActivate: [LoggedInGuard],
  },
  {
    path: "integration/:integrationId",
    component: DocsComponent,
    data: { title: "Integration Docs", docsSection: "assistant-docs" },
    canActivate: [LoggedInGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DocsRoutingModule {}

const docsModuleLazyLoadRoutes: Routes = [
  {
    path: "docs",
    loadChildren: () => import("./docs.module").then((m) => m.DocsModule),
  },
];

export { docsModuleLazyLoadRoutes };
